<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { ArrowRight, Flame, RotateCcw, Star, Target } from 'lucide-vue-next';
import { cl_api, cl_errorMessage } from '@/api';
import { useLearnerStore } from '@/stores/learner';

interface ClMission { cl_lesson: { slug: string; title: string; explanation: string } | null; cl_reviewCount: number; cl_wordGoal: number; cl_minutes: number; }
const cl_learner = useLearnerStore(); const cl_mission = ref<ClMission | null>(null); const cl_error = ref('');
onMounted(async () => { try { cl_mission.value = (await cl_api.get('/courses/today', { params: { cl_childId: cl_learner.cl_activeChildId } })).data; } catch (cl_cause) { cl_error.value = cl_errorMessage(cl_cause); } });
</script>

<template>
  <section class="cl-page cl-home">
    <div class="cl-welcome"><p class="cl-eyebrow">Hello, {{ cl_learner.cl_activeChild?.name }}!</p><h1>Today's Mission</h1></div>
    <p v-if="cl_error" class="cl-form-error">{{ cl_error }}</p>
    <div v-if="cl_mission?.cl_lesson" class="cl-mission-band">
      <div><span class="cl-mission-kicker">今天学习</span><h2>{{ cl_mission.cl_lesson.title }}</h2><p>{{ cl_mission.cl_lesson.explanation }}</p></div>
      <div class="cl-mission-meta"><span><Target />{{ cl_mission.cl_wordGoal }} 个单词</span><span><Flame />约 {{ cl_mission.cl_minutes }} 分钟</span></div>
      <RouterLink class="cl-primary-button" :to="`/lesson/${cl_mission.cl_lesson.slug}`">开始学习 <ArrowRight /></RouterLink>
    </div>
    <div class="cl-stat-strip">
      <div><Flame /><strong>{{ cl_learner.cl_activeChild?.profile.currentStreak ?? 0 }}</strong><span>连续学习</span></div>
      <div><Star /><strong>{{ cl_learner.cl_activeChild?.profile.totalStars ?? 0 }}</strong><span>学习星星</span></div>
      <div><Target /><strong>{{ cl_mission?.cl_reviewCount ?? 0 }}</strong><span>今日复习</span></div>
    </div>
    <div class="cl-home-actions"><RouterLink to="/map"><h3>课程地图</h3><p>查看自然拼读学习路线</p><ArrowRight /></RouterLink><RouterLink to="/parent"><h3>家长中心</h3><p>查看发音趋势与薄弱音素</p><ArrowRight /></RouterLink></div>
    <RouterLink v-if="cl_mission?.cl_reviewCount" class="cl-review-callout" to="/review"><RotateCcw /><span><strong>今日复习</strong><small>{{ cl_mission.cl_reviewCount }} 个到期任务，根据薄弱音素动态安排</small></span><ArrowRight /></RouterLink>
  </section>
</template>
